import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import { useAppMeta } from "hooks";

import { useCreateAdjustmentMutation } from "store/services/PaymentsApi/adjustmentApi";
import AdjustmentForm from "./AdjustmentComponents/AdjustmentForm";

const AdjustmentCreateScreen = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Adjustments", path: "/app/crm/adjustment/list" },
    { title: "New Adjustment" },
  ];

  const [createAdjustment, { isLoading: creatingAdjustment }] =
    useCreateAdjustmentMutation();

  const handleAddAdjustment = async (data) => {
    try {
      const { _id } = await createAdjustment(data).unwrap();
      toast.success("Adjustment Created!");
      navigate(`/app/crm/adjustment/${_id}/detail`);
    } catch (error) {
      toast.error(
        error?.data?.message ?? error.message ?? "Could not create adjustment!"
      );
    }
  };

  useAppMeta("New Adjustment");

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingAdjustment}>
      <BreadcrumbLayout.Paper>
        <AdjustmentForm
          isBusy={creatingAdjustment}
          onSubmit={handleAddAdjustment}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default AdjustmentCreateScreen;
